/* global axios */
import ApiClient from '../ApiClient';

class PilotCustomTools extends ApiClient {
  constructor() {
    super('pilot/custom_tools', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: { page, searchKey },
    });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data = {}) {
    return axios.post(this.url, {
      custom_tool: data,
    });
  }

  update(id, data = {}) {
    return axios.put(`${this.url}/${id}`, {
      custom_tool: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // 测试工具调用
  test(id, testParams = {}) {
    return axios.post(`${this.url}/${id}/test`, {
      test_params: testParams,
    });
  }
}

export default new PilotCustomTools();
